<template>
	<div class="c-theme-picker">
		<div
			v-for="theme in themes"
			:key="theme.id"
			class="c-theme-picker__theme"
			:data-theme="theme.id"
			tabindex="0"
			@click="onClick(theme.id)"
		>
			<div class="c-theme-picker__theme__frame">
				<span>
					<span> </span>
					<span> </span>
				</span>
				<span>
					<span></span>
					<span></span>
				</span>
			</div>
			<p>
				{{ theme.name }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		themes: function () {
			return [
				{
					name: 'Default',
					id: 'default',
				},
				{
					name: 'Earth',
					id: 'earth',
				},
				{
					name: 'Pristina',
					id: 'pristina',
				},
				{
					name: 'Desert',
					id: 'desert',
				},
			];
		},
	},

	methods: {
		onClick: function (themeId) {
			let ui = {
				theme: themeId,
			};
			this.$store.dispatch('settings/saveUiState', ui);
		},
	},
};
</script>

<style lang="scss">
.c-theme-picker {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-column-gap: var(--spacer);
	grid-row-gap: var(--margin-lg);
	width: 100%;
	justify-items: stretch;
	align-items: stretch;

	&__theme {
		text-align: center;

		> p {
			margin-top: var(--margin);
			opacity: 0.75;
		}

		&__frame {
			height: 80px;
			background-color: var(--g1);
			display: grid;
			grid-template-rows: 70% 30%;
			grid-column-gap: 0;
			grid-row-gap: 0;
			border-radius: var(--border-radius);
			//border: rgba(255, 255, 255, 0.75) solid 2px;
			overflow: hidden;
			transition: box-shadow var(--transition-time) ease-out;
			cursor: pointer;

			> span {
				display: grid;
				grid-template-columns: 30% 70%;
				grid-column-gap: 0;
				grid-row-gap: 0;
				background-color: var(--g1);
				background-color: var(--g3);

				> span {
					background-color: var(--g4);

					&:nth-child(2) {
						background-color: var(--g5);
					}
				}

				&:last-child {
					background-color: var(--p1);

					> span {
						background-color: var(--p3);

						&:nth-child(2) {
							background-color: var(--p2);
						}
					}
				}
			}
		}

		&:focus-active {
			.c-theme-picker__theme__frame {
				outline: none;
				@include focus(4px);
			}
		}
		&:hover {
			.c-theme-picker__theme__frame {
				@include focus(4px);
			}
		}
	}
}
</style>